import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, catchError, lastValueFrom, throwError } from 'rxjs';
import { OrganisationSettingsService, OrganisationSettingWithGplView } from '@src/api';
import { UserUI } from '@src/models';

import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root',
})
export class PreferencesService {
  private readonly api = inject(OrganisationSettingsService);
  private readonly alertService = inject(AlertService);

  settings$ = new BehaviorSubject<OrganisationSettingWithGplView | undefined>(undefined);

  private items: OrganisationSettingWithGplView = {
    showParentOrgUsersInLists: false,
    showOnlyChannelsInNewsFeed: false,
    enableLoyaltyNewsletters: false,
    darkThemeByDefault: false,
    showOnlyLoyaltyProgram: false,
  };

  private orgId?: string;

  get settings() {
    return this.items;
  }

  getData(user?: UserUI) {
    this.orgId = user?.parentOrganisationId;

    return this.refresh();
  }

  async refresh(): Promise<OrganisationSettingWithGplView> {
    if (this.orgId) {
      this.items = await lastValueFrom(this.getDataByOrganisationId(this.orgId));
      this.items.showParentOrgUsersInLists ??= true;
      this.items.showOnlyChannelsInNewsFeed ??= false;
      this.items.enableLoyaltyNewsletters ??= false;
      this.items.darkThemeByDefault ??= false;
      this.items.showOnlyLoyaltyProgram ??= false;
    }

    this.settings$.next(this.items);

    return this.settings;
  }

  getDataByOrganisationId(orgId: string) {
    return this.api.organisationSettingsByOrganisationId(orgId).pipe(
      catchError(err => {
        this.alertService.error(err.error);
        return throwError(() => err);
      }),
    );
  }
}
